import React, { useState } from 'react';
import Header from '../master/SideBar';
import Nav from '../master/NavBar';

export default function StudentAdmissionForm() {
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        studentName: '',
        fatherName: '',
        motherName: '',
        mobile: '',
        dob: '',
        gender: '',
        village: '',
        district: '',
        state: '',
        pincode: '',
        lastEducation: '',
        schoolName: '',
        referredBy: '',
        course: '',
        batch: '',
        transport: '',
        busRoute: '',
        sendWhatsapp: false,
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form Submitted:', formData);
    };

    const tabs = [
        { id: 1, title: "Basic Details" },
        { id: 2, title: "Address" },
        { id: 3, title: "Additional Details" },
        { id: 4, title: "Course Details" },
        { id: 5, title: "Transport" }
    ];

    return (
        <>
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <Header />
                    <div className="layout-page">
                        <Nav />
                        <div className="mb-4">
                            <div className="container-fluid flex-grow-1 pt-2"></div>
                            <div className="container">
                                {/* HEADER + TABS CARD */}
                                <div className="card shadow mb-3 mt-4">
                                    <div className="card-body">
                                        <div className="pb-5">
                                            <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
                                                <h5 className="mb-2 fw-bold text-primary fs-4">Student Admission</h5>
                                                <button className="btn btn-outline-primary">
                                                    <i className="bi bi-arrow-left-circle me-1"></i>
                                                    Back
                                                </button>
                                            </div>
                                        </div>

                                        {/* Stepper Tracker */}
                                        <div className="position-relative mt-5 mb-3 px-2">
                                            <div className="progress" style={{ height: '4px' }}>
                                                <div
                                                    className="progress-bar bg-primary"
                                                    role="progressbar"
                                                    style={{ width: `${((step - 1) / (tabs.length - 1)) * 100}%` }}
                                                ></div>
                                            </div>

                                            <div
                                                className="d-flex justify-content-between position-absolute w-100 top-0 flex-nowrap overflow-auto"
                                                style={{ transform: 'translateY(-50%)', gap: '0.5rem' }}
                                            >
                                                {tabs.map(tab => (
                                                    <button
                                                        key={tab.id}
                                                        className={`btn btn-sm px-3 py-1 rounded border flex-shrink-0 ${step === tab.id ? 'btn-primary text-white' : 'btn-outline-primary bg-white'}`}
                                                        onClick={() => setStep(tab.id)}
                                                        style={{ zIndex: 1 }}
                                                    >
                                                        {tab.title}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>




                                {/* FORM CARD */}
                                <div className="card shadow">
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            {/* TAB 1: Basic Details */}
                                            {step === 1 && (
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <label>Registration No <span className='text-danger'>*</span></label>
                                                        <input type="text" className="form-control input-capitalize" name="studentName" value={formData.studentName} onChange={handleChange} required />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>Student Name  <span className='text-danger'>*</span></label>
                                                        <input type="text" className="form-control input-capitalize" name="studentName" value={formData.studentName} onChange={handleChange} required />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>Father Name  <span className='text-danger'>*</span></label>
                                                        <input type="text" className="form-control input-uppercase" name="fatherName" value={formData.fatherName} onChange={handleChange} required />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>Mother Name</label>
                                                        <input type="text" className="form-control input-uppercase" name="motherName" value={formData.motherName} onChange={handleChange} />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>Mobile No  <span className='text-danger'>*</span></label>
                                                        <input type="tel" className="form-control" name="mobile" value={formData.mobile} onChange={handleChange} required />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>Alternate No. </label>
                                                        <input type="tel" className="form-control" name="alternate" value={formData.alternate} onChange={handleChange} required />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>Gender <span className='text-danger'>*</span></label>
                                                        <select className="form-control" name="gender" value={formData.gender} onChange={handleChange}>
                                                            <option value="">Select Gender</option>
                                                            <option value="Male">Male</option>
                                                            <option value="Female">Female</option>
                                                            <option value="Other">Other</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>Email </label>
                                                        <input type="email" className="form-control" name="email" value={formData.email} onChange={handleChange} required />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>Category <span className='text-danger'>*</span></label>
                                                        <select className="form-control" name="category" value={formData.category} onChange={handleChange}>
                                                            <option value="">Select Category</option>
                                                            <option value="GEN">GEN</option>
                                                            <option value="EWS">EWS</option>
                                                            <option value="OBC">OBC</option>
                                                            <option value="SC">SC</option>
                                                            <option value="ST">ST</option>
                                                            <option value="MBC">MBC</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>Aadhar No. </label>
                                                        <input type="text" className="form-control" name="aadhar" value={formData.aadhar} onChange={handleChange} required />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>Date of Birth  <span className='text-danger'>*</span></label>
                                                        <input type="date" className="form-control" name="dob" value={formData.dob} onChange={handleChange} />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>NIC ID </label>
                                                        <input type="text" className="form-control" name="nic_id" value={formData.nic_id} onChange={handleChange} required />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>Apaar ID </label>
                                                        <input type="text" className="form-control" name="Apaar" value={formData.Apaar} onChange={handleChange} required />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>RTE Status <span className="text-danger">*</span></label>
                                                        <select
                                                            className="form-control"
                                                            name="category"
                                                            value={formData.category}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select RTE / Non-RTE</option>
                                                            <option value="RTE">RTE</option>
                                                            <option value="NON-RTE">Non-RTE</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-1 mt-5">
                                                        <label htmlFor="imageInput" className="btn btn-outline-primary d-flex align-items-center">
                                                            <i className="bi bi-camera-fill me-2"></i> Profile
                                                            <input
                                                                type="file"
                                                                id="imageInput"
                                                                name="image"
                                                                accept="image/png, image/jpeg, image/jpg"
                                                                hidden
                                                            />
                                                        </label>
                                                    </div>

                                                </div>
                                            )}

                                            {/* TAB 2: Address */}
                                            {step === 2 && (
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <label>Village</label>
                                                        <input type="text" className="form-control input-uppercase" name="village" value={formData.village} onChange={handleChange} />
                                                    </div>
                                                    {/* <div className="col-md-4">
                                                        <label>Tehsil</label>
                                                        <input type="text" className="form-control" name="tehsil" value={formData.tehsil} onChange={handleChange} />
                                                    </div> */}
                                                    <div className="col-md-4">
                                                        <label>District</label>
                                                        <input type="text" className="form-control" name="district" value={formData.district} onChange={handleChange} />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>State</label>
                                                        <input type="text" className="form-control input-uppercase" name="state" value={formData.state} onChange={handleChange} />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>Pincode</label>
                                                        <input type="text" className="form-control" name="pincode" value={formData.pincode} onChange={handleChange} />
                                                    </div>
                                                </div>
                                            )}

                                            {/* Tab 3: Additional Details */}
                                            {step === 3 && (
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <label>Last Education</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="lastEducation"
                                                            value={formData.lastEducation}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>School Name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control input-uppercase"
                                                            name="schoolName"
                                                            value={formData.schoolName}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>Referred By</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="referredBy"
                                                            value={formData.referredBy}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                            )}

                                            {/* TAB 3: Course Details */}
                                            {step === 4 && (
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <label>Course</label>
                                                        <input type="text" className="form-control input-capitalize" name="course" value={formData.course} onChange={handleChange} />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label>Batch</label>
                                                        <input type="text" className="form-control" name="batch" value={formData.batch} onChange={handleChange} />
                                                    </div>
                                                </div>
                                            )}

                                            {/* TAB 4: Transport */}
                                            {step === 5 && (
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <label>Transport</label>
                                                        <input type="text" className="form-control" name="transport" value={formData.transport} onChange={handleChange} />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label>Bus Route</label>
                                                        <input type="text" className="form-control" name="busRoute" value={formData.busRoute} onChange={handleChange} />
                                                    </div>
                                                    <div className="col-md-12 mt-3">
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                name="sendWhatsapp"
                                                                checked={formData.sendWhatsapp}
                                                                onChange={handleChange}
                                                                id="sendWhatsapp"
                                                            />
                                                            <label className="form-check-label text-primary fw-semibold" htmlFor="sendWhatsapp">
                                                                Send Admission WhatsApp Message
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="d-flex justify-content-between mt-4">
                                                {step > 1 && (
                                                    <button type="button" className="btn btn-label-primary" onClick={() => setStep(step - 1)}>
                                                        <i className="bi bi-arrow-left-circle me-1"></i> Back
                                                    </button>
                                                )}
                                                {step < 5 && (
                                                    <button type="button" className="btn btn-primary" onClick={() => setStep(step + 1)}>
                                                        Next &nbsp; <i className="bi bi-arrow-right-circle me-1"></i>
                                                    </button>
                                                )}
                                                {step === 5 && (
                                                    <button type="submit" className="btn btn-success">
                                                        Submit
                                                    </button>
                                                )}
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
